export const componentName = 'B2bGenerateBox';
